import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { HttpApiService } from '@recruitee/http';
import { LocationBrief } from '@recruitee/http-types';

@Injectable({
  providedIn: 'root',
})
export class LocationsByCompanyHttpService {
  constructor(private httpApi: HttpApiService) {}

  public fetchOne$(id: string): Observable<{ locations: LocationBrief[]; id: string }> {
    const url = `${this.httpApi.appConfig.apiUrl}c/${id}/locations`;

    return this.httpApi.get(url, undefined, { skipURLBuild: true }).pipe(
      map(response => ({
        locations: response.locations,
        id,
      })),
    );
  }
}
